import { render, staticRenderFns } from "./DialogPageChatToolbar.vue?vue&type=template&id=2a1fd5e0"
import script from "./DialogPageChatToolbar.vue?vue&type=script&lang=js"
export * from "./DialogPageChatToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports